module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_comment-03-567549ec7065c0ae78e28bf5182b7666.png";